<template>
    <div class="table-list accounting-book">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <modal class="delete-bill" :display="modalStatus.deleteLedger" @modalStatus="closeAlarmModal" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除記帳</h1>
            <div class="content">
                確定刪除 ”{{ledgerName}}”的記帳嗎？記錄確認刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteLedger(), $analytics.logEvent('刪除記帳本', { screen_name: '刪除記帳本'})">確認</button>
                <button class="border-button" @click="closeAlarmModal">取消</button>
            </div>
        </modal>
        <edit-accounting :key="componentKey" :accountingDetail="accountingBookList[selected]"></edit-accounting>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="date">時間</span>
            <span class="house">房源名稱</span>
            <span class="address">地址</span>
            <span class="source">記帳項目</span>
            <span class="income">收支</span>
            <span class="amount">總金額</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-show="filterByWord.length == 0 && accountingBookList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-show="accountingBookList.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="date">{{getFormatDate(list.recordingDate)}}</span>
                    <span class="house">{{list.houseName}}</span>
                    <span class="address">{{list.address}}</span>
                    <span class="source">{{list.itemName}}</span>
                    <span class="income">{{transType(list.incomeExpense)}}</span>
                    <span class="amount red">{{toCurrency(list.amount)}}</span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="editAccounting(index), componentKey += 1, $analytics.logEvent('編輯記帳', { screen_name: '編輯記帳'})">編輯</li>
                                <li @click="ledgerName = list.houseName, ledgerId = list.cid, openAlarmModal()">刪除</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import editAccounting from '@/components/widge/editAccounting.vue';
import { 
    apiDeleteLedger
    } from "@/apis/api.js"; 


import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            componentKey: 0,
            selected: 0,
            ledgerId: null,
            ledgerName: null,
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            modalStatus: {
                deleteLedger: false
            },
        }
    },
    mounted () {
        this.$analytics.logEvent("記帳本", {
            screen_name: "記帳本"
        });
        this.$store.dispatch('getAccountingBookMgtList')
    },
    watch: {
        filterByWord:{
            handler: function (val) {
                // console.log(val)
                this.$store.dispatch('setAccountingFilterResultTotal',  val.length)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setAccountingFilterDefault')
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        // transSource: function (value) {
        //     if( value == 'BOOKING_DEPOSIT' ){
        //         return '訂金'
        //     }else if( value == 'CONTRACT_DEPOSIT' ) {
        //         return '押金'
        //     }else if( value == 'CONTRACT_BILL' ) {
        //         return '帳單'
        //     }else if( value == 'HOUSE_TASK_BONUS' ) {
        //         return '委託獎金'
        //     }
        // },
        // transType: function (value) {
        //     if( value == 'INCOME' ){
        //         return '收入'
        //     }else if( value == 'EXPENSE' ) {
        //         return '支出'
        //     }
        // },
        editAccounting: function (index) {
            this.selected = index
            this.$store.dispatch('setModalStatus', {state: true, type: 'editAccounting'})
        },
        openAlarmModal: function () {
            this.modalStatus.deleteLedger = true
            document.getElementsByClassName('financial-accounting')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        closeAlarmModal: function () {
            this.$store.commit('modalStatus/set_modal_mode', false)
            this.modalStatus.deleteLedger = false
        },
        deleteLedger: function () {
            let data = {
                ledgerCid: this.ledgerId
            }
            apiDeleteLedger(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('getAccountingBookMgtList')
                    this.closeAlarmModal()
                    // console.log(res)
                }
            })
            .catch(err => {
                reject(err)
            })
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        fileterByHouse: function () {
            return this.accountingBookList.filter((item) => {
                if(this.filterQuery.houseName){
                    if(item.houseName == this.filterQuery.houseName){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        fileterByType: function () {
            return this.fileterByHouse.filter((item) => {
                if(this.filterQuery.type){
                    if(item.incomeExpense == this.filterQuery.type){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByAmount: function () {
            return this.fileterByType.filter((item) => {
                if( this.filterQuery.amount ){
                    if( this.filterQuery.amount[1] >= 100000){
                        if( this.filterQuery.amount[0] <= item.amount){
                            return item
                        }
                    }else{
                        if( this.filterQuery.amount[0] <= item.amount && this.filterQuery.amount[1] >= item.amount ){
                            return item
                        }
                    }
                    
                }else{
                    return item
                }
            });
        },
        filterByDate: function () {
            return this.filterByAmount.filter((item) => {
                if(this.filterQuery.date){
                    if(item.recordingDate == this.filterQuery.date){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByDate.filter((item) => {
                if( this.filterWord ){
                    if( item.houseName.includes(this.filterWord) || item.address.includes(this.filterWord) || item.itemName.includes(this.filterWord)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            accountingBookList: 'GET_ACCOUNTING_BOOK_MGT_LIST',
            filterQuery: 'GET_ACCOUNTING_BOOK_MGT_FILTER_QUERY',
            filterWord: 'GET_ACCOUNTING_BOOK_MGT_FILTER_WORD',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        AlartMsg,
        Modal,
        editAccounting
    }
}
</script>
<style lang="scss" scoped>
    .table-list.accounting-book{
        // .table-list-title .house:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .house:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
        #modal.delete-bill{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #676362;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .table-list-title .date,
        .table-list-body ul li .date{
            width: 80px;
            margin-right: 47px;
        }
        .table-list-title .house,
        .table-list-body ul li .house{
            position: relative;
            width: 200px;
            margin-right: 45px;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 300px;
            margin-right: 45px;
        }
        .table-list-title .source,
        .table-list-body ul li .source{
            width: 108px;
            margin-right: 37px;
        }
        .table-list-title .income,
        .table-list-body ul li .income{
            width: 28px;
            margin-right: 55px;
        }
        .table-list-title .amount,
        .table-list-body ul li .amount{
            width: 51px;
            margin-right: 48px;
        }
        .table-list-body ul li .amount{
            text-align: right;
        }
        .table-list-body ul li .amount.blue{
            color: #3942b5;
        }
        .table-list-body ul li .amount.red{
            color: #ff9275;
        }
    }
    @media screen and (max-width: 1280px){
        .table-list.accounting-book{
            .table-list-title .house,
            .table-list-body ul li .house{
                margin-right: 48px;
            }
            .table-list-title .tanant,
            .table-list-body ul li .tanant{
                margin-right: 54px;
            }
            .table-list-title .phone,
            .table-list-body ul li .phone{
                margin-right: 64px;
            }
            .table-list-title .address,
            .table-list-body ul li .address{
                margin-right: 44px;
            
            }
            .table-list-title .rent,
            .table-list-body ul li .rent{
                margin-right: 32px;
            }
            .table-list-title .leave-date,
            .table-list-body ul li .leave-date{
                margin-right: 70px;
            }
        }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/financialManagement/financialAccounting.vue